export default __webpack_public_path__ + "static/media/PrivacyPolicy.6d409740.pdf";